import { jsxs as l, jsx as r } from "react/jsx-runtime";
import "react";
import { p as o } from "../../index-DB0QlRo7.mjs";
import '../../assets/Figure2.css';const s = "_figure_1wcw1_1", c = {
  figure: s
};
function f({ image: t = { url: "", altText: "", caption: "" } }) {
  return /* @__PURE__ */ l(
    "figure",
    {
      className: c.figure,
      title: t.altText !== "" ? t.altText : "",
      children: [
        /* @__PURE__ */ r("img", { src: t.url, alt: t.altText }),
        (t == null ? void 0 : t.caption) && /* @__PURE__ */ r("figcaption", { children: o(t.caption) })
      ]
    }
  );
}
export {
  f as Figure,
  f as default
};
